<template>
  <div class="ml-5 mr-5 pb-5">
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>

    <h4 class="titre1 mb-5 mt-4">GESTION DES JEUX DE REQUETES</h4>
    <div class ="container">
    <b-button id="show-modal" class="ajout mb-2 mt-2" @click.prevent="showModalAddJeu = !showModalAddJeu">
      Ajouter un jeu de requête</b-button>
        <ModalAdd v-if="showModalAddJeu" @close="showModalAddJeu = false" @notification="handleNotification"></ModalAdd>

    <b-card bg-variant="secondary"
     v-bind:key ="jeuRequete.idJeuRequetes" 
     v-for="jeuRequete in jeuRequetes" class="mb-3 mt-3">
      <ItemAccordion
      :JeuRequetesData="jeuRequete">
      </ItemAccordion>
    </b-card>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import http from '@/http.js'
import eventBus from '@/eventBus.js'
import ItemAccordion from "@/components/JeuRequetes/ItemAccordion.vue"
import ModalAdd from "@/components/JeuRequetes/ModalAddJeu.vue"
import NotificationMessage from "@/components/Notification.vue";


  export default {
    name: "JeuRequetesList",
    components:{
      NotificationMessage,
      ItemAccordion,
      ModalAdd

    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup() {
      const jeuRequetes = ref([]);
      const jeuRequetesData = ref({});
      const showModalAddJeu = ref(false);

      const showNotification = ref(false);
      const notificationMessage = ref("");
      const notificationType = ref("info");

      const handleNotification = ({ toastMessage, toastType }) => {
        notificationMessage.value = toastMessage;
        notificationType.value = toastType;
        showNotification.value = true;
        setTimeout(() => {
          showNotification.value = false;
        }, 5000);
      };
      eventBus.on("notification", handleNotification);

      const getJeux = async () => {
        const data = await http.getJeux();
        jeuRequetes.value = data;
      };

      onMounted(() => {
        getJeux();
        eventBus.on("reloadJeu", getJeux);
      });

      return {
        jeuRequetes,
        jeuRequetesData,
        showModalAddJeu,
        showNotification,
        notificationMessage,
        notificationType,
        handleNotification
      };
    }
  }
</script>

<style>

.requetes{
padding-left: 0 !important;
padding-right: 0 !important;

}
.card-body{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.afficher{
  padding-top: 1em !important;
  padding-bottom: 1em !important;
  color:black !important;
  text-align: center !important;
}
.titres{
  font-size: 20px;
}
.titre1{
  text-align:left !important; 
}
.ajout{
  background-color: #f0f0f0 !important; 
  margin-bottom: 5em !important;
  color:black !important;
  font-size: 20px;
}
.ajout:hover{
  background-color:#C0C0C0 !important;
  color: white !important;
  text-decoration:none; 
}
.nav-link1{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #00a3a6;
}
.nav-link1:hover{
  color: black !important;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}
.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}
.nav-link4{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #275662;
}
.nav-link4:hover{
  color: black !important;
}
.nav-link5{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #66c1bf;
}
.nav-link5:hover{
  color: black !important;
}
</style>